export default {
  businessLogisticsCompany: {
    common: {
      add: 'Add',
      status: 'Status',
      addBusiness: 'Add Business',
      editBusiness: 'Edit Business',
      addAssociated: 'Add Associated',
      editAssociated: 'Edit Associated',
    },
    table: {
      logisticsCompanyName: 'Courier Service Name',
      logisticsCompanyName2: 'Logistics Provider',
      status: 'Status',
      creator: 'Created By',
      createTime: 'Date Created',
      action: 'Operation ',
      logisticsCompanyNameInput: 'Please enter logistics provider name',
      chooseText: 'Please Select',
    },
  }
};
